module.exports = __webpack_public_path__ + "static/media/coins.3be98f43.svg";